import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const"
import VScroll from "../../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import MultiselectPopoverSearch from "./popover-search"
import MultiselectPopoverOptionsSelector from "./popover-options-selector"

const SEARCH_SHOW_THRESHOLD = 6 // min options to show search input

const popoverPosition = new PopoverPosition({
    attachment      : "top center",
    targetAttachment: "bottom center",
    attachmentType  : PopoverAttachmentType.FULL,
})

type Props = {
    parent  : any
    options : any[]
}

type State = {
    searchString : string | null
}

export default class UsersMultiselectPopoverMenu extends React.Component<Props, State> {

    private optionsSelector : any
    private scroll          : any

    constructor(props:Props) {
        super(props)

        this.state = {
            searchString: null
        }
    }

    onPopoverKeyDown = (e:any) => {if(this.optionsSelector) this.optionsSelector.onPopoverKeyDown(e)}

    onSearchChange = (newSearchString:string) => {
        this.setState({
            searchString: newSearchString
        })
    }

    updateScroll = (node:any) => {
        if (!this.scroll) return

        const scrollNode:any = findDOMNode(this.scroll.childrenContainer)

        const nodeTop = node.offsetTop
        const nodeBottom = node.offsetTop + node.offsetHeight
        const scrollTop = scrollNode.scrollTop
        const scrollBottom = scrollNode.scrollTop + scrollNode.offsetHeight

        // ensure node to be in visible area of scroll
        if (scrollBottom < nodeBottom) this.scroll.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop) this.scroll.setScrollTop(nodeTop, false, 100)
    }

    render() {
        return (
            <Popover position={popoverPosition}
                     getTargetFunc={()=>findDOMNode(this.props.parent)}
                     onKeyDown={this.onPopoverKeyDown}
                     onClickOutside={()=>{this.props.parent.hidePopover()}}>

                <MultiselectPopoverSearch searchable={this.props.options.length > SEARCH_SHOW_THRESHOLD}
                                          searchString={this.state.searchString}
                                          onHidePopover={this.props.parent.hidePopover}
                                          onSearchChange={this.onSearchChange}/>

                <div className="ui5-popover-menu min-w-200">
                    <VScroll containerClass="max-h-300" scrollVisibility="auto">
                        <MultiselectPopoverOptionsSelector ref={r=>this.optionsSelector = r}
                                                           parent={this.props.parent}
                                                           options={this.props.options}
                                                           searchString={this.state.searchString}
                                                           onUpdateScroll={this.updateScroll}/>
                    </VScroll>
                </div>
            </Popover>
        )
    }
}
